import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons"

export const PhoneAlt = (props) => {
  return <FontAwesomeIcon faIcon={faPhoneAlt} {...props} />
}
